import { useEffect, useState } from 'react'
import type { Pagina } from '../api/tipos'

/**
 * Retrasa un valor hasta que el usuario deja de escribir. Evita mandar una
 * consulta por tecla: en la tienda la conexion no siempre es buena.
 */
export function usarRetardo<T>(valor: T, milisegundos = 300): T {
    const [retrasado, setRetrasado] = useState(valor)

    useEffect(() => {
        const temporizador = setTimeout(() => setRetrasado(valor), milisegundos)
        return () => clearTimeout(temporizador)
    }, [valor, milisegundos])

    return retrasado
}

interface Props {
    pagina: Pagina<unknown> | null
    alCambiar: (pagina: number) => void
}

export function Paginador({ pagina, alCambiar }: Props) {
    if (!pagina || pagina.totalPaginas <= 1) return null

    return (
        <nav className="fila entre g3 paginador" aria-label="Paginación">
            <button
                type="button"
                className="boton"
                disabled={pagina.pagina <= 1}
                onClick={() => alCambiar(pagina.pagina - 1)}
            >
                Anterior
            </button>

            <span className="tenue chico numero">
                {pagina.pagina} / {pagina.totalPaginas} · {pagina.total} registros
            </span>

            <button
                type="button"
                className="boton"
                disabled={!pagina.hayPaginaSiguiente}
                onClick={() => alCambiar(pagina.pagina + 1)}
            >
                Siguiente
            </button>
        </nav>
    )
}
